import { createVNode, createTextVNode } from "inferno";
const VARIABLE_TYPE_ID = 'dmn-boxed-expression-variable-type';
export default function ElementVariableComponent(_, context) {
  const viewer = context.injector.get('viewer');

  // there is only one single element
  const {
    name,
    variable
  } = viewer.getRootElement();
  const type = variable ? variable.get('typeRef') : 'Any';
  return createVNode(1, "div", "element-variable", [createVNode(1, "h2", null, createTextVNode("Result"), 2), createVNode(1, "div", null, name, 0), createVNode(1, "div", "element-variable-type", [createVNode(1, "span", "element-variable-type-label", createTextVNode("Result type"), 2), createVNode(1, "span", null, type, 0, {
    "id": VARIABLE_TYPE_ID
  })], 4)], 4);
}
//# sourceMappingURL=ElementVariableComponent.js.map